import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { FormSignatureObjectUseCase } from './FormSignatureObjectUseCase';
import { AutoLoginUseCase } from './AutoLoginUseCase';
import { DevicePairingUseCase } from './DevicePairingUseCase';
import { ForgotPasswordResendOTPUseCase } from './ForgotPasswordResendOTPUseCase';
import { ForgotPasswordResetUseCase } from './ForgotPasswordResetUseCase';
import { ForgotPasswordVerifyOTPUseCase } from './ForgotPasswordVerifyOTPUseCase';
import { ForgotPasswordSendOTPUseCase } from './ForgotPasswordSendOTPUseCase';
import { LoginWithCredentialsUseCase } from './LoginWithCredentialsUseCase';
import { LoginWithOTPUseCase } from './LoginWithOTPUseCase';
import { RefreshAuthTokenUseCase } from './RefreshAuthTokenUseCase';
import { VerifyQRCodeUseCase } from './VerifyQRCodeUseCase';
import { VerifyUsernameUseCase } from './VerifyUsernameUseCase';
import { VerifyUserUseCase } from './VerifyUserUseCase';
import { ZendeskJWTTokenUseCase } from './ZendeskJWTTokenUseCase';
import { LogoutUseCase } from './LogoutUseCase';
import { GetGuestPublicConfigUseCase } from './GetGuestPublicConfigUseCase';
import { LoginGuestUseCase } from './LoginGuestUseCase';
import { ForgetResendPinUseCase } from './ForgetResendPinUseCase';
import { FormSignatureUseCase } from './FormSignatureUseCase'
import { VerifyEmailUseCase } from './VerifyEmailUseCase';
import { LocateUsernameUseCase } from './LocateUsernameUseCase';
import { B2BForgetPinUseCase } from './B2BForgetPinUseCase';

export const initializeAuthUseCases = (container: Container) => {
    container.register(DI.USECASES.IAutoLoginUseCase, {
        useClass: AutoLoginUseCase,
    });
    container.register(DI.USECASES.IDevicePairingUseCase, {
        useClass: DevicePairingUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordResendOTPUseCase, {
        useClass: ForgotPasswordResendOTPUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordResetUseCase, {
        useClass: ForgotPasswordResetUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordSendOTPUseCase, {
        useClass: ForgotPasswordSendOTPUseCase,
    });
    container.register(DI.USECASES.IForgotPasswordVerifyOTPUseCase, {
        useClass: ForgotPasswordVerifyOTPUseCase,
    });
    container.register(DI.USECASES.ILoginWithCredentialsUseCase, {
        useClass: LoginWithCredentialsUseCase,
    });
    container.register(DI.USECASES.ILoginWithOTPUseCase, {
        useClass: LoginWithOTPUseCase,
    });
    container.register(DI.USECASES.IGetGuestPublicConfigUseCase, {
        useClass: GetGuestPublicConfigUseCase,
    });
    container.register(DI.USECASES.ILoginGuestUseCase, {
        useClass: LoginGuestUseCase,
    });
    container.register(DI.USECASES.IRefreshAuthTokenUseCase, {
        useClass: RefreshAuthTokenUseCase,
    });
    container.register(DI.USECASES.IVerifyQRCodeUseCase, {
        useClass: VerifyQRCodeUseCase,
    });
    container.register(DI.USECASES.IVerifyUsernameUseCase, {
        useClass: VerifyUsernameUseCase,
    });
    container.register(DI.USECASES.IVerifyUserUseCase, {
        useClass: VerifyUserUseCase,
    });
    container.register(DI.USECASES.IZendeskJWTTokenUseCase, {
        useClass: ZendeskJWTTokenUseCase,
    });
    container.register(DI.USECASES.IFormSignatureObjectUseCase, {
        useClass: FormSignatureObjectUseCase,
    });
    container.register(DI.USECASES.ILogoutUseCase, {
        useClass: LogoutUseCase,
    });
    container.register(DI.USECASES.IForgetResendPinUseCase, {
        useClass: ForgetResendPinUseCase,
    });
    container.register(DI.USECASES.IFormSignatureUseCase, {
        useClass: FormSignatureUseCase,
    });
    container.register(DI.USECASES.IVerifyEmailUseCase, {
        useClass: VerifyEmailUseCase,
    });
    container.register(DI.USECASES.ILocateUsernameUseCase, {
        useClass: LocateUsernameUseCase,
    });
    container.register(DI.USECASES.IB2BForgetPinUseCase, {
        useClass: B2BForgetPinUseCase,
    });

};
